import { render, staticRenderFns } from "./product-setting-display.vue?vue&type=template&id=20b78e7c&scoped=true&"
import script from "./product-setting-display.vue?vue&type=script&lang=js&"
export * from "./product-setting-display.vue?vue&type=script&lang=js&"
import style0 from "./product-setting-display.vue?vue&type=style&index=0&id=20b78e7c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b78e7c",
  null
  
)

export default component.exports